import { Component, OnInit } from '@angular/core';
import Typo from 'typo-js';

@Component({
    selector: 'app-spell-checker',
    templateUrl: './spell-checker.component.html',
    styleUrls: ['./spell-checker.component.css'],
    standalone: false
})
export class SpellCheckerComponent implements OnInit {
  typo!: Typo;
  inputText = '';
  suggestions: string[] = [];

  async ngOnInit() {
    const aff = await fetch('/i18n/es_ES/index.aff').then((res) => res.text());
    const dic = await fetch('/i18n/es_ES/index.dic').then((res) => res.text());

    this.typo = new Typo('es_AR', aff, dic);
  }

  onInputChange(text: string) {
    this.inputText = text;
    const words = text.trim().split(/\s+/);
    const lastWord = words[words.length - 1];

    if (this.typo) this.suggestions = this.typo.suggest(lastWord);
  }

  replaceWord(suggestion: string) {
    const words = this.inputText.trim().split(/\s+/);
    words[words.length - 1] = suggestion;
    this.inputText = words.join(' ') + ' ';
    this.suggestions = [];
  }
}
